<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class AirlinesSearchMixin extends Vue {
        async searchAirlines(rq) {
            return (await this.$api.airlines.get({...{limit: 10}, ...rq})).airlines
        }
    }

    export default AirlinesSearchMixin
</script>
